export default "__VITE_ASSET__CFfzeKB9__"